import React, { useEffect, useState } from 'react';
import NavTop from './NavTop';
import brndLogo2 from '../../assets/images/02.jpg'
import Navmd from './Navmd';
import { Link } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar';
import CartSide from '../sidebar/CartSide';
import SearchSide from '../sidebar/SearchSide';
import { useSelector } from 'react-redux';
import { MdOutlineFavoriteBorder } from "react-icons/md";
import { useTranslation } from 'react-i18next';

const Navigation = () => {
    const { wishlist } = useSelector((state) => state.wishlist);
    const [isSticky, setSticky] = useState(false);
    const { t } = useTranslation();
    
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 40) {
                setSticky(true)
            } else {
                setSticky(false)
            }
        })
    }, []);

    return (
        <>
            <div className='nav-mb broder-2'>
                <NavTop isSticky={isSticky} />
                <div id={`${isSticky ? 'navbar-fixd' : 'nav-py-4'}`} className={`navigation hidden xl:block bg-white ${isSticky && 'shadow-md'}`}>
                    <nav className='xl:container mx-auto xl:px-20 px-2 font-poppins font-medium'>
                        <div className="flex">
                            <div className="flex-none w-auto h-14">
                                <div className="nav-img h-full md:pr-2 ">
                                    <Link to="/" >
                                        <img className='object-fill h-full w-auto rounded' src={brndLogo2} alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="grow h-14">
                                <div>
                                    <ul className='flex flex-wrap md:flex-row md:space-x-1  text-sm px-5'>

                                        <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                            <Link to="/" className='hover:no-underline hover:text-inherit'>{t('home.nav.home')}</Link>
                                        </li>
                                        <li className='relative group py-3 px-2 cursor-pointer text-gray-600'>
                                            <Link to="/nav-filter/perfume" className='hover:no-underline  hover:text-amber-600'>{t('home.nav.perfume')}</Link>
                                            <div className="absolute hidden bg-grey-200 group-hover:block w-36">
                                                <div className="px-1 py-1 bg-white shadow-lg rounded">
                                                    <ul className='text-gray-600 py-1'>
                                                        <li className='py-1.5 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                                            <Link to="/nav-filter/allOverPerfume" className='hover:no-underline hover:text-inherit'>{t('home.nav.All-Over-perfume')}</Link>
                                                        </li>
                                                        <li className='py-1.5 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                                            <Link to="/nav-filter/sleepingSpray" className='hover:no-underline hover:text-inherit'>{t('home.nav.Sleeping-Spray')}</Link>
                                                        </li>
                                                        <li className='py-1.5 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                                            <Link to="/nav-filter/giftBox" className='hover:no-underline hover:text-inherit'>{t('home.nav.Gift-box')}</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                        <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                            <Link to="/nav-filter/floorFreshener" className='hover:no-underline hover:text-inherit'>{t('home.nav.floor-Freshener')}</Link>
                                        </li>
                                        <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                            <Link to="/nav-filter/perfumeOil" className='hover:no-underline hover:text-inherit'>{t('home.nav.Perfume-Oill')}</Link>
                                        </li>
                                        <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                            <Link to="/nav-filter/hairMix" className='hover:no-underline hover:text-inherit'>{t('home.nav.Hair-Mix')}</Link>
                                        </li>
                                        {/* <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>Sleeping Spray</li>
                                    <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>Gift Box</li> */}
                                        <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                            <Link to="/nav-filter/specialDay" className='hover:no-underline hover:text-inherit'>{t('home.nav.Special-Dy')}</Link>
                                        </li>
                                        <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                            <Link to="/nav-filter/wholeSale" className='hover:no-underline hover:text-inherit'>{t('home.nav.Whole-Sale')}</Link>
                                        </li>
                                        <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>
                                            <Link to="/contact-us" className='hover:no-underline hover:text-inherit'>{t('home.nav.Contact-us')}</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="flex-none w-14 h-14">
                                <div className="h-full flex justify-center md:space-x-5">
                                    <div className="cursor-pointer serch-icon grid content-center">
                                        <SearchSide />
                                    </div>
                                    <div className="cart-icon grid content-center">
                                        <Sidebar side="right" forItem="cart" >
                                            <CartSide />
                                        </Sidebar>
                                    </div>
                                    
                                    {
                                        wishlist.length > 0 && (
                                            <div className="cart-icon grid content-center">
                                                <Link to="/wishlist">
                                                    <button type="button" className="focus:outline-none inline-flex relative items-center p-2 text-sm font-medium text-center text-white">
                                                        <MdOutlineFavoriteBorder className='block text-2xl text-black hover:text-bnd-1' />
                                                        <span className="sr-only">Notifications</span>
                                                        <div className="inline-flex absolute -top-1 -right-0 rounded justify-center items-center w-auto px-1 h-5 text-xs font-semibold text-white bg-bnd-1">{wishlist ? wishlist.length : 0}</div>
                                                    </button>
                                                </Link>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>

            </div>
            <Navmd />
        </>
    );
};

export default Navigation;